import { SearchMode } from "./search";

export interface TextSearchFilter {
  query: string;
  columnFilters: Record<string, string>;
  mode: SearchMode;
}
export type LogFilter = TextSearchFilter;

export const isTextSearchFilter = (
  filter: LogFilter,
): filter is TextSearchFilter => {
  return "query" in filter && filter.query !== undefined && "mode" in filter;
};
